import classNames from 'classnames';
import { getKeys } from 'shared/lib/object';
import { isValidDay } from 'entities/campaign';
import type { SchedulingUpdateCellProps } from 'entities/history';

export function SchedulingUpdateCell({ data }: SchedulingUpdateCellProps) {
  return (
    <div data-testid="TestId__scheduling-update">
      {getKeys(data)
        .filter(isValidDay)
        .map((day) => {
          const oldValue = data[day].old;
          const newValue = data[day].new;

          const getOldValueStyles = (prevTime: string | undefined, newTime: string) =>
            classNames('w-[65px] mr-[18px] pl-[7px] pr-1', {
              'custom-line-through': !!oldValue && prevTime !== newTime,
              inactive: !newValue.isSelected,
            });

          return (
            <div
              className={classNames(
                'flex justify-between text-xs w-[334px] py-3 pr-3 border-b border-slate-100 last:border-0',
                { 'text-slate-400': !newValue.isSelected }
              )}
              key={day}
            >
              <div className="font-semibold">{day}</div>
              <div>
                <div className="flex flex-row">
                  <div className="mr-[25px]">From</div>
                  <div className={getOldValueStyles(oldValue?.timeFrom, newValue.timeFrom)}>
                    {!!oldValue && oldValue.timeFrom}
                  </div>
                  <div className="mr-[13px]">to</div>
                  <div>{newValue.timeFrom}</div>
                </div>
                <div className="mt-[7px] flex flex-row">
                  <div className="mr-[25px]">From</div>
                  <div className={getOldValueStyles(oldValue?.timeTo, newValue.timeTo)}>
                    {!!oldValue && oldValue.timeTo}
                  </div>
                  <div className="mr-[13px]">to</div>
                  <div>{newValue.timeTo}</div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
}
